import * as React from 'react';
import {Component} from 'react';
import * as screenTypes from '../../../../constants/ScreenTypes';
import {Loader} from 'semantic-ui-react';
import DesignScreen from '../../Design/components/Design';
import DesignMainMenu from '../../Design/derivatives/mainMenu/MainMenu';
import PersonalMenu from '../../PersonalMenu/components/PersonalMenu';
import ContainerScreen from '../../Containers/components/Container';
import SystemReportScreen from '../../SystemReport/components/SystemReport';
import TemplateReportScreen from '../../TemplateReport/components/TemplateReport';
import PackagesScreen from '../../Packages/components/Package';

interface Props {
    screen: any;
}

export default class Screen extends Component<Props, null> {
    render() {
        const {screen} = this.props;
        const {loading, name} = screen;
        if (loading) {
            return <Loader active inline="centered" />;
        } else {
            switch (name) {
                case screenTypes.design.ACTIVATIONS:
                case screenTypes.design.COLUMNS:
                case screenTypes.design.SUBLEVELS:
                case screenTypes.design.TREE: {
                    return <DesignScreen {...this.props} />;
                }
                case screenTypes.report.CONTAINERS: {
                    return <ContainerScreen {...this.props} />;
                }
                case screenTypes.report.TEMPLATES: {
                    return <TemplateReportScreen {...this.props} />;
                }
                case screenTypes.report.SYSTEMFORMATS: {
                    return <SystemReportScreen {...this.props} />;
                }
                case screenTypes.menu.MAINMENU: {
                    return <DesignMainMenu {...this.props} />;
                }
                case screenTypes.menu.PERSONALMENU: {
                    return <PersonalMenu {...this.props} />;
                }
                case screenTypes.design.PACKAGES: {
                    return <PackagesScreen {...this.props} />;
                }
                default:
                    return null;
            }
        }
    }
}
